/**
 * Як стандартне подання показує список (прототип v4 Groundwork.dc.html L5384-5390, UIUX tables/pagination): посторінково (таблиця, картки,
 * редагування в рядку) чи весь відфільтрований список (етапи, беклог, розділений, календар) з рядком «N записів»; що показує порожній список.
 * Чисті функції.
 */

/** Подання з пагінацією; решта стандартних показують увесь список. */
const PAGED: readonly string[] = ['table', 'cards', 'inline'];

/** Чи подання показує список посторінково. */
export function isPagedView(view: string): boolean {
  return PAGED.includes(view);
}

/** Де рядок «N записів»: над дошкою й календарем (прототип рендерить його перед ними), під таблицею етапів; інакше — немає. */
export function countPlacement(view: string): 'above' | 'below' | null {
  if (view === 'backlog' || view === 'calendar') return 'above';
  return view === 'stages' ? 'below' : null;
}

/**
 * Порожній список: таблиця й картки — рамка з реченням і дією; етапи — вкладки етапів і рамка (вкладки лишаються, щоб перемкнути етап);
 * дошка, календар, розділений і редагування в рядку — саме подання (порожні колонки, сітка календаря, рядок додавання).
 */
export function emptyModeOf(view: string): 'box' | 'tabs' | 'view' {
  if (view === 'table' || view === 'cards') return 'box';
  return view === 'stages' ? 'tabs' : 'view';
}

/** Подання, над якими список сам показує примітку про сховані стовпці (прототип v4 hasColsHidden): таблиця, етапи й редагування в рядку
 * показують її над сіткою самі, розділений вигляд — без неї. */
const FIT_NOTE: readonly string[] = ['cards', 'backlog', 'calendar'];

/** Чи список показує над поданням примітку про стовпці, сховані за шириною. */
export function notesHiddenColumns(view: string): boolean {
  return FIT_NOTE.includes(view);
}
